import { render, staticRenderFns } from "./param-dhis2.html?vue&type=template&id=55635286&scoped=true&external"
import script from "./param-dhis2.js?vue&type=script&lang=js&external"
export * from "./param-dhis2.js?vue&type=script&lang=js&external"
import style0 from "./param-dhis2.scss?vue&type=style&index=0&id=55635286&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55635286",
  null
  
)

export default component.exports